export default {"src":"/_next/static/media/arrow.a694c94b.svg","height":12,"width":7};